import React, { useContext } from 'react';
import classnames from 'classnames';

import Context from "../context/context";


const NavItem = props => {
  const {activeFilters } = useContext(Context);
  const {widget, toggleFilterNav} = props;

  let filter_count = 0;
  if (typeof widget.filters != "undefined"){
    filter_count = activeFilters[widget.filters[0].name].value.length;
  }

  return (
    <>
    <div
      className={classnames('filter-section-trigger filter-nav-item ', {
        open: widget.open
      })}
      onClick={() => toggleFilterNav(widget)}
    >
    <div className="filter-nav-item-top">
      <div className="filter-trigger-name  filter-nav-title">{widget.title}</div>
      <span aria-hidden="true" className="sr-only"> (</span>
      <span
      className={classnames('filter-count', {
        active: filter_count > 0
      })}>{filter_count}</span>
      <span className="sr-only" aria-hidden="true"> filters selected)</span>
      <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.949219 1.37915L5.89897 6.3289L0.949219 11.2786" stroke="white" stroke-width="2"/>
      </svg>
    </div>


    </div>
    </>
  )
}

export default NavItem;
